// Tailwind class sets shared by forms and row actions.
//
// Phone first: every control is at least 44px on a touch screen and every
// field is at least 16px text (smaller text makes iOS Safari zoom in on focus).
// `pointer-fine:` (a mouse or trackpad) brings back the compact desktop sizes.

/** A touch target of at least 44px square; compact again under a mouse. */
export const tapTarget = 'min-h-11 min-w-11 pointer-fine:min-h-0 pointer-fine:min-w-0';

/** An icon-only button: the icon centered in a 44px touch target. Add padding and color. */
export const iconButton = `inline-flex items-center justify-center ${tapTarget}`;

/** A link that stands on its own line (Back, All digests): 44px tall to touch, its text unchanged. */
export const tapLink = 'inline-flex items-center min-h-11 pointer-fine:min-h-0';

export const inputClass =
  'w-full min-h-11 pointer-fine:min-h-0 px-3 py-2 text-base rounded-xl border border-outline/30 bg-surface focus:outline-none focus:ring-2 focus:ring-primary/30';

/** A date or time field sized to its content, so a date and a time share one line. */
export const compactInput =
  'w-auto min-h-11 pointer-fine:min-h-0 px-2 py-1 text-base pointer-fine:text-sm rounded-lg border border-outline/30 bg-surface focus:outline-none focus:ring-2 focus:ring-primary/30';

const button = `inline-flex items-center justify-center gap-1 ${tapTarget} px-3 py-1.5 rounded-xl text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed`;

export const outlineButton = `${button} border border-outline/30 hover:bg-surface-variant`;

export const primaryButton = `${button} bg-primary text-on-primary hover:bg-primary/90`;

export const dangerButton = `${button} bg-error text-on-error hover:bg-error/90`;

/**
 * A dialog's backdrop. On a phone the dialog sits at the top, clear of the
 * keyboard, and scrolls when taller than the screen; wider, it is centered.
 * The padding keeps it off the notch and the home indicator.
 */
export const dialogBackdrop =
  'fixed inset-0 z-50 flex items-start sm:items-center justify-center overflow-y-auto bg-scrim/50 ' +
  'pt-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))] ' +
  'pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))]';

/** The dialog panel inside dialogBackdrop. */
export const dialogPanel = 'w-full max-w-lg rounded-xl bg-surface p-4 sm:p-6 shadow-xl';

// Sign-in, reset and set-password screens.

export const authInput =
  'w-full px-4 py-3 text-base rounded-xl border border-outline/30 bg-surface focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary';

export const authSubmit =
  'w-full min-h-11 py-3 bg-primary text-on-primary rounded-xl font-medium hover:bg-primary/90 transition-colors disabled:opacity-50';

export const authError = 'p-3 rounded-xl bg-error/10 text-error text-sm';

export const authNotice = 'p-3 rounded-xl bg-primary-container text-on-surface text-sm';
